module.exports = __webpack_public_path__ + "static/media/Collection-outdoor-experiences-Mobile.de9e369f.webp";